module.exports = __webpack_public_path__ + "img/calendar-solid.2423d58c.svg";